import { render, staticRenderFns } from "./rptsupplierorder.vue?vue&type=template&id=ad522afa"
import script from "./rptsupplierorder.vue?vue&type=script&lang=js"
export * from "./rptsupplierorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports